import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { Location } from '@angular/common';
import { NavigationEnd, Router } from '@angular/router';

@Component({
  selector: 'app-back-page',
  templateUrl: './back-page.component.html',
  styleUrls: ['./back-page.component.scss']
})
export class BackPageComponent  {
  @Output() backAction = new EventEmitter()
  constructor(private location: Location, public Router: Router) { }

  back() {
    this.backAction.emit('back')
    this.location.back()
  }

}
